import { render } from "./ContractFileDetail.vue?vue&type=template&id=573c4b87"
import script from "./ContractFileDetail.vue?vue&type=script&lang=js"
export * from "./ContractFileDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__